<template>
	<div class="fullscreen-form">
		
			<h2 class="headline" v-if="name">{{name}}</h2>
			<div class="page-indicator">
				<span>{{currentPage}}</span> / <span>{{totalPages}}</span>
			</div>

			<div class="page-navigation">
				<span v-bind:class="{ active: index+1 == currentPage }" v-for="(page, index) in keys" @click="toPage(index+1)"></span>
			</div>

			<template v-for="(key, index) in keys">
				<fsInput 
				:class="formData[key].class" 
				:show="index == currentPage - 1"
				:showError="formData[key].showError" 
				:type="formData[key].type" 
				:placeholder="formData[key].placeholder" 
				:descr="formData[key].descr" 
				:label="formData[key].label" 
				:options="formData[key].options" 
				:validation="formData[key].validation"
				:name="key"
				v-model="formData[key].value"  
				@enter="nextPage" />
			</template>

			<template v-for="(key, index) in hiddenKeys">
				<input type="hidden"
				:name="key"
				v-model="formData[key].value"  
				/>
			</template>

			<!-- This might be for later: having a summary page or so... -->
			<!-- <div class="form-list">
				<template v-for="(item, index) in formData">
					<fsInput simplified="true" :type="item.type" :placeholder="item.placeholder" :descr="item.descr" :label="item.label" v-model="item.value"/>
				</template>
			</div> -->
			
			
			<button :class="{ last: currentPage >= totalPages }" :disabled="(allFilled == false || allValidated == false) && currentPage >= totalPages" class="submit-button" @click="nextPage" type="button">
				<template v-if="currentPage < totalPages">
					Weiter
				</template>
				<template v-else>
					Abschicken
				</template>
			</button>
			<form v-if='action' :action="action" method="POST" v-on:submit.prevent ref="form">
				<input v-for="(key, index) in allKeys" type="hidden" :value="formData[key].value" :name="key">
			</form>
	</div>
</template>

<script>
    import fsInput from "@/components/fullscreenFormInput"
    import _ from "lodash"

	export default {
		props: {
			name: {
				default: false
			},
			formData: {
				default() {
					return {}
				}
			},
			action: {
				default: null,
			},
		},
		components: {
            "fsInput": fsInput
        },
		data() {
			return {
				currentPage: 1,
			}
		},
		mounted() {
			if (this.action) {
				this.$refs.form.action = this.action;
			}
		},

		created() {
			for (var key in this.formData) {
				this.$set( this.formData[key], "showError", false );
				if (this.formData[key].value == undefined) {
					this.$set( this.formData[key], "value", "" );
				}
			}
		},
		methods: {
			toPage(index) {
				this.currentPage = index;
			},
			nextPage() {
				// first check required

				if (this.formData[this.keys[this.currentPage-1]].required && (this.formData[this.keys[this.currentPage-1]].value == "" || this.formData[this.keys[this.currentPage-1]].value == undefined || this.formData[this.keys[this.currentPage-1]].value == null)) {
                    this.formData[this.keys[this.currentPage-1]].showError = true;
                    return;
                } else {
                    this.formData[this.keys[this.currentPage-1]].showError = false;
                }
				if (this.currentPage<this.totalPages) {
					this.currentPage++;
				} else {
					this.submit();
				}
			},

			submit() {
				if (this.allFilled && this.allValidated) {
					if (this.action == null) {
						this.$emit("submit", this.formData);
					} else {
						
						this.$refs.form.submit()
					}
					
				}
			}
		}, 
		computed: {
			notHiddenInputs() {
				return _.omitBy(this.formData, (o) => {
					return o.type == "hidden"
				})
			},
			hiddenInputs() {
				return _.omitBy(this.formData, (o) => {
					return o.type != "hidden"
				})
			},
			allKeys() {
				return Object.keys(this.formData);
			},
			totalPages () {
				return Object.keys(this.notHiddenInputs).length;
			},

			keys() {
				return Object.keys(this.notHiddenInputs);
			},

			submitType() { return this.action == null ? 'button' : 'submit' },

			hiddenKeys() {
				return Object.keys(this.hiddenInputs);
			},
			allFilled() {
				for (var key in this.formData) {
					if (this.formData[key].required) {
						if (this.formData[key].value == "" || 
							this.formData[key].value == undefined ||
							this.formData[key].value == null) {
							return false;
						}
					}
				}
				return true;
			},

			allValidated() {
				for (var key in this.formData) {
					if (this.formData[key].validation) {
						if (!this.formData[key].validation(this.formData[key].value)) {
							return false;
						}
					}
				}
				return true;
			}
		}
	}
</script>


<style scoped lang="scss">
	$font-color: $dark-grey;
	$highlight-color: white;
	$background-color: $primary-color;

	.fullscreen-form {
		position: relative;
		width: 100%;
		height: 100%;
		top: 0px;
    	left: 0px;
	}

	.page-indicator {
		position: absolute;
		top: 0.8em;
		right: 0.8em;
		font-size: 2em;
		font-weight: 200;
		color: rgba($font-color, 0.3);
		z-index: 2;
	}

	.page-indicator span {
		font-weight: bold;
		color: rgba($font-color, 0.6);
	}

	.page-navigation {
		position: absolute;
		top: 50%;
		right: 1em;
		font-size: 1.3em;
		transform: translateY(-50%);
		z-index: 3;
	}

	h2.headline {
		position: absolute;
		top: 0.8em;
		left: 0.8em;
		font-size: 2em;
		opacity: 0.3;
		max-width: calc(100% - 0.8em - 3.5em);
		color: $highlight-color;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.page-navigation span {
		display: block;
		margin: 0.7em 0em;
		width: 0.7em;
		height: 0.7em;
		background-color: $font-color;
		transition: all 0.3s ease;
		border-radius: 2em;
		cursor: pointer;
		opacity: 0.3;
	}

	.page-navigation span.active {
		opacity: 1;
	}

	.submit-button {
		border-radius: 0px;
		border: 2px solid $font-color;
		background-color: $font-color;
		color: $background-color;
		padding: 0.7em 1.3em;
		font-size: 1em;
		text-align: center;
		width: auto;
		position: absolute;
		bottom: 1.3em;
		right: 1.3em;
		cursor: pointer;
		opacity: 0.8;
		transition: all 0.2s linear, transform 0.05s ease-in-out;
		outline: none;
		z-index: 4;
	}
	.submit-button:hover {
		opacity: 1;
		background-color: $background-color;
		color: $font-color;
	}

	.submit-button:active {
		transform: scale(0.96,0.96);
	}

	.submit-button.last {
		border-color: $highlight-color;
		background-color: $highlight-color;
		color: $background-color;
	}

	.submit-button.last:hover {
		color: $highlight-color;
		background-color: $background-color;
	}

	button[disabled] {
		opacity: 0.2;
		pointer-events: none;
	}

	/* For Iphone X */
	@media only screen 
    and (device-width : 375px) 
    and (device-height : 812px) 
    and (-webkit-device-pixel-ratio : 3) {
    	.submit-button {
    		bottom: 2.5em;
    	}
    }
</style>




// WEBPACK FOOTER //
// src/components/fullscreenForm.vue